import { a as m, j as r } from "../../../emotion-react-jsx-runtime.browser.esm-CsRinUqv.js";
import { Colors as s } from "../../1-foundations/Colors/Colors.js";
import "@ionic/react";
import "../../../FeatureFlagProvider-BBppjvNP.js";
import "react";
import "../../../react-paginate-Lh5zQzpz.js";
import "../../organisms/LoadingInterstitial/LoadingInterstitial.js";
import "../../contexts/DesignSystemProvider/DesignSystemProvider.js";
function u(i) {
  const {
    children: t,
    title: o
  } = i;
  return /* @__PURE__ */ m("div", {
    children: [!!o && /* @__PURE__ */ r("h3", {
      css: {
        margin: 0,
        marginBottom: 16
      },
      children: o
    }), /* @__PURE__ */ r("div", {
      css: {
        borderRadius: 8,
        backgroundColor: s.white200
      },
      children: t
    })]
  });
}
export {
  u as IconBlockGroup
};
